import { StoryRow } from '~/pages/posts/PostStory'
import { Maybe, MediaAlignmentType, Meetup } from '~/api/generated/graphql'
import { MediaComponent } from '~/pages/posts/MediaComponent'
import MentionableText from '~/common/MentionableText'
import { asHtmlWithMentions } from '~/utils'

type PostStoryRowProps = {
  row: StoryRow
  index?: number
  meetup?: Meetup
  commentId?: string
  postId?: string
  repostId?: Maybe<string>
  primaryVideoUrl?: Maybe<string>
  sensitiveAttachment?: boolean
}
const PostStoryRow = ({
  row,
  index,
  meetup,
  commentId,
  postId,
  repostId,
  primaryVideoUrl,
  sensitiveAttachment,
}: PostStoryRowProps) => {
  const { alignment, mediaType, mediaUrl, story, filename } = row

  return (
    <div
      className={`post-story-row${alignment === MediaAlignmentType.RightMedia ? ' right-media' : ''}${
        alignment === MediaAlignmentType.FullText ? ' full-text' : ''
      }`}
    >
      {mediaUrl && mediaType && (
        <div className={`row-media-container${alignment === MediaAlignmentType.FullMedia ? ' full' : ''}`}>
          <div className={'media-holder'}>
            <div className={'media-item'}>
              <MediaComponent
                media_type={mediaType}
                url={mediaUrl}
                uploading={false}
                content_title={filename ?? undefined}
                index={index}
                post_id={postId}
                sensitive_attachment={sensitiveAttachment ?? false}
                comment_id={commentId}
              />
            </div>
          </div>
        </div>
      )}
      {story && (
        <div className={`row-quill-container${alignment === MediaAlignmentType.FullText ? ' full' : ''}`}>
          <MentionableText
            value={asHtmlWithMentions(story)}
            meetup={meetup}
            commentId={commentId}
            postId={postId}
            repostId={repostId}
            primaryVideoUrl={primaryVideoUrl}
          />
        </div>
      )}
    </div>
  )
}

export default PostStoryRow
